import {
  getStaticPropsGenerator,
  GetStaticPropsGeneratorArgs,
} from '@cinch-nx/landing-feature-seo-pages'

const path = 'seo-pages/car-inspection'

export const getStaticProps = getStaticPropsGenerator(
  path as unknown as GetStaticPropsGeneratorArgs,
)

export { SEOPageFeature as default } from '@cinch-nx/landing-feature-seo-pages'
